/* CaseCrush — site-wide phone picker gate (Step 1).
   Brand tiles first, then a model-card grid for the chosen brand (no
   dropdown). Search bypasses the brand step and shows flat matches across
   every brand. Same universal brand/model list every product page's own
   selector uses (templates/product.json, custom_liquid_8pjdnR). Picking a
   model saves it as cart attributes ('Phone Brand', 'Phone Model') and
   redirects back to ?return_to= (or /collections/all). The collection-page
   gate in layout/theme.liquid reads that same attribute. */
(function () {
  'use strict';

  var PREFERRED_BRAND_ORDER = [
    'Apple', 'Samsung', 'Google', 'OnePlus', 'Redmi',
    'Poco', 'Realme', 'Oppo', 'Vivo', 'Motorola', 'Nothing',
  ];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function normalize(str) {
    return String(str || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function getReturnTo() {
    var params = new URLSearchParams(window.location.search);
    var target = params.get('return_to');
    if (target && target.charAt(0) === '/' && target.charAt(1) !== '/') {
      return target;
    }
    return '/collections/all';
  }

  ready(function () {
    var dataEl = document.getElementById('cc-phone-models');
    var logosEl = document.getElementById('cc-phone-brand-logos');
    var searchInput = document.getElementById('cc-phone-search');
    var brandStepEl = document.getElementById('cc-phone-brand-step');
    var brandTiles = document.getElementById('cc-phone-brand-tiles');
    var modelStepEl = document.getElementById('cc-phone-model-step');
    var backBtn = document.getElementById('cc-phone-back');
    var modelHeadingEl = document.getElementById('cc-phone-model-heading');
    var modelGrid = document.getElementById('cc-phone-model-grid');
    var noResultsEl = document.getElementById('cc-phone-no-models');

    if (!brandTiles || !modelGrid) return;

    var models = [];
    try {
      models = JSON.parse((dataEl && dataEl.textContent) || '[]');
    } catch (e) {
      models = [];
    }

    var brandLogos = {};
    try {
      brandLogos = JSON.parse((logosEl && logosEl.textContent) || '{}');
    } catch (e) {
      brandLogos = {};
    }

    var brands = [];
    models.forEach(function (m) {
      if (brands.indexOf(m.brand) === -1) brands.push(m.brand);
    });
    brands.sort(function (a, b) {
      var ai = PREFERRED_BRAND_ORDER.indexOf(a);
      var bi = PREFERRED_BRAND_ORDER.indexOf(b);
      if (ai === -1) ai = PREFERRED_BRAND_ORDER.length;
      if (bi === -1) bi = PREFERRED_BRAND_ORDER.length;
      return ai - bi;
    });

    var currentBrand = null;

    function selectModel(model) {
      var url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
      var returnTo = getReturnTo();
      var done = false;
      function proceed() {
        if (done) return;
        done = true;
        try {
          sessionStorage.removeItem('ccPhoneGateBounces');
        } catch (e) {}
        window.location.href = returnTo;
      }
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: { 'Phone Brand': model.brand, 'Phone Model': model.model },
        }),
      }).then(proceed).catch(proceed);
      // Safety net in case the request hangs — still proceed either way.
      setTimeout(proceed, 2500);
    }

    function renderModelCards(list) {
      modelGrid.innerHTML = '';
      if (!list.length) {
        modelGrid.hidden = true;
        if (noResultsEl) noResultsEl.hidden = false;
        return;
      }
      modelGrid.hidden = false;
      if (noResultsEl) noResultsEl.hidden = true;
      list.forEach(function (model) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cc-model-card';
        btn.setAttribute('role', 'listitem');
        btn.textContent = model.model;
        btn.addEventListener('click', function () { selectModel(model); });
        modelGrid.appendChild(btn);
      });
    }

    function showModelStep(heading, list) {
      if (brandStepEl) brandStepEl.hidden = true;
      if (modelStepEl) modelStepEl.hidden = false;
      if (modelHeadingEl) modelHeadingEl.textContent = heading;
      renderModelCards(list);
    }

    function showBrandStep() {
      if (modelStepEl) modelStepEl.hidden = true;
      if (brandStepEl) brandStepEl.hidden = false;
    }

    function renderBrandTiles() {
      brandTiles.innerHTML = '';
      brands.forEach(function (brand) {
        var brandModels = models.filter(function (m) { return m.brand === brand; });
        var tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'cc-phone-brand-tile';
        tile.setAttribute('role', 'listitem');

        var icon = document.createElement('span');
        icon.className = 'cc-phone-brand-tile__icon';
        icon.setAttribute('aria-hidden', 'true');
        var logoSrc = brandLogos[brand];
        if (logoSrc) {
          var logoImg = document.createElement('img');
          logoImg.src = logoSrc;
          logoImg.alt = '';
          logoImg.loading = 'lazy';
          icon.appendChild(logoImg);
        } else {
          icon.classList.add('cc-phone-brand-tile__icon--fallback');
          icon.textContent = brand.charAt(0);
        }

        var name = document.createElement('span');
        name.className = 'cc-phone-brand-tile__name';
        name.textContent = brand;

        var count = document.createElement('span');
        count.className = 'cc-phone-brand-tile__count';
        count.textContent = brandModels.length + (brandModels.length === 1 ? ' model' : ' models');

        tile.appendChild(icon);
        tile.appendChild(name);
        tile.appendChild(count);

        tile.addEventListener('click', function () {
          currentBrand = brand;
          showModelStep(brand, brandModels);
        });

        brandTiles.appendChild(tile);
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        currentBrand = null;
        if (searchInput) searchInput.value = '';
        showBrandStep();
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var query = normalize(searchInput.value);
        if (!query) {
          if (currentBrand) {
            showModelStep(currentBrand, models.filter(function (m) { return m.brand === currentBrand; }));
          } else {
            showBrandStep();
          }
          return;
        }
        var matches = models.filter(function (m) { return normalize(m.model).indexOf(query) !== -1; });
        showModelStep('Search results', matches);
      });
    }

    renderBrandTiles();
    showBrandStep();
  });
})();
